import type { UploadFile } from 'antd/lib/upload/interface';
import { SetState } from 'zustand';
import { MeterAccessibility } from '@enmon/commons/lib/enmon';
import type { InventorizeMeterStore } from '../../useStore';
import type { StepMeterDetails } from '../../types';

const INITIAL_STATE: DetailStepForm = {
  accessibility: [MeterAccessibility.Good],
  lat: undefined,
  lng: undefined,
  internalNote: undefined,
  photoDetailList: undefined,
  serialNumber: undefined,
  lorawanRssi: undefined,
  nbiotRssi: undefined,
  detail: undefined,
  twinMeter: 0,
};

export interface DetailStepForm {
  accessibility?: MeterAccessibility[];
  lat?: number;
  lng?: number;
  internalNote?: string;
  photoDetailList?: UploadFile[];
  serialNumber?: string;
  lorawanRssi?: number;
  nbiotRssi?: number;
  twinMeter?: number | null;
  apiKey?: string | null;
  detail?: StepMeterDetails;
}

export type DetailStepSlice = DetailStepForm & {
  resetDetailStepSlice: (initValues?: Partial<DetailStepForm>) => void;
  setDetailStepValues: (values: DetailStepForm) => void;
  setPhotoDetailList: (payload: UploadFile[]) => void;
  setSerialNumber: (payload?: string) => void;
};

export const createDetailStepSlice = (set: SetState<InventorizeMeterStore>): DetailStepSlice => ({
  ...INITIAL_STATE,
  resetDetailStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
  setDetailStepValues: (values: Partial<DetailStepForm>) => set(values),
  setPhotoDetailList: (payload: UploadFile[]) =>
    set(() => ({
      photoDetailList: payload,
    })),
  setSerialNumber: (payload: string | undefined) =>
    set(() => ({
      serialNumber: payload,
    })),
});
